<!--
  Custom Content Component ("Dowolna treść")

  Generic content block: a heading and a rich-text body. Meant to be reused in
  any context to drop in arbitrary copy. Heading color derives from
  `site_context` so it stays consistent within each clinic. Max content width is
  1200px.
-->
<template>
  <section class="flex flex-col items-center justify-center px-4 py-16 w-full bg-white md:px-16">
    <div class="custom-content mx-auto flex w-full max-w-[1200px] flex-col gap-6">
      <h2
        v-if="title"
        class="text-[36px] font-medium leading-[44px] tracking-[-0.72px]"
      >
        {{ title }}
      </h2>

      <!-- content is sanitized server-side via HtmlSanitizer; v-html is safe. -->
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div
        v-if="content"
        class="prose prose-lg max-w-none text-dark"
        v-html="content"
      />
    </div>
  </section>
</template>

<script setup>
defineProps({
  title:   { type: String, default: '' },
  content: { type: String, default: '' },
  // eslint-disable-next-line vue/prop-name-casing
  site_context: { type: String, default: null },
});
</script>
